export default function MultiAgent() {
  return (
    <>
      <div class="row_binary">
        <div class="column_binary">
          <div class="container_float">
            <h2>Multi-agents simulation :</h2>
            <br />
            <p className="binary_content">
              {" "}
              The goal of this project is to create mutli-agents simulation. It
              is about the correlation between environmental awareness and the
              use of ressources.
              <br />
              <br />
              This project has been done entirely in Java using Jade.
            </p>
          </div>
        </div>
        <div class="column_binary">
          <div class="container_float">
            <h2>Links :</h2>
            <br />
            <h3>
              Project presentation :{" "}
              <a href="https://github.com/Viktor-hash/Mutli-agents-project/blob/main/Pr%C3%A9sentation.pdf">
                Project repository
              </a>
            </h3>
          </div>
        </div>
      </div>
      <div class="footer_projects">
        <p>© Victor Perrault 2023. Currently in Hong Kong</p>
      </div>
    </>
  );
}
